import React from 'react';
import apple from '../assets/img/app-store.svg';
import google from '../assets/img/google-play.png';

const JuegoComponent = ({titulo = 'Titulo', img='', altImg='img', descripcion=<p>Descripción</p>, linkApple='#', linkGoogle='#'}) => {
    return (
        <section className='topic'>
            <div className="nes-container with-title is-rounded container-margin-24">
                <p className="title">{titulo}</p>
                <div>
                    <center>
                        <img src={img}
                            alt={altImg}
                            className="img-game"
                        />
                    </center>
                    {" "}
                    <div className='description-game'>
                        {descripcion}
                    </div>
                    {" "}
                    <div className='description-game'>
                        <center>
                        {linkGoogle !== '#' &&
                            <>
                                <a href={linkGoogle} target="_blank" rel="noreferrer">
                                    <img src={google} width="220px" alt="google" />
                                </a>
                                {" "}
                            </>
                        }
                        {linkApple !== '#' &&
                            <>
                                <a href={linkApple} target="_blank" rel="noreferrer">
                                    <img src={apple} width="200px" alt="apple" />
                                </a>
                                {" "}
                            </>
                        }
                        </center>
                        

                    </div>
                </div>
            </div>
        </section>
    );
};

export default JuegoComponent;

    